"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _ClippableText = _interopRequireDefault(require("@mulesoft/client-applications-ui/raw/components/ClippableText"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var styles = {
  "modal": "ResultModal__modal__1bBct",
  "header": "ResultModal__header__3NgnS",
  "body": "ResultModal__body__3WLD9",
  "footer": "ResultModal__footer__1kcRp",
  "title": "ResultModal__title__3psTH",
  "approved": "ResultModal__approved__mcr4X",
  "message-body": "ResultModal__message-body__1_VLl",
  "messageBody": "ResultModal__message-body__1_VLl",
  "client-application-details": "ResultModal__client-application-details__1Yj5e",
  "clientApplicationDetails": "ResultModal__client-application-details__1Yj5e",
  "label": "ResultModal__label__bW1uU"
}; 
require('./ResultModal.css');
var ManualApprovalContent = function ManualApprovalContent() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    className: styles.header,
    "data-test-id": "manual-approval-header"
  }, "Your request has been received and is pending."), /*#__PURE__*/_react.default.createElement("p", {
    className: styles.messageBody,
    "data-test-id": "manual-approval-message"
  }, "You will be notified by email when the status changes, or you can check it on the application page."));
};
var AutoApprovalContent = function AutoApprovalContent(props) {
  var applicationPath = props.applicationPath,
    isAPIGroup = props.isAPIGroup,
    clientId = props.clientId,
    clientSecret = props.clientSecret;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    className: (0, _classnames.default)(styles.header, styles.approved),
    "data-test-id": "success-header"
  }, "Your request has been received and approved."), /*#__PURE__*/_react.default.createElement("p", {
    className: styles.messageBody,
    "data-test-id": "success-message"
  }, "Use this client ID and client secret to access", ' ', isAPIGroup ? 'the API instances in the requested API Group' : 'the requested API instance', ". You can always find these values at the", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: applicationPath,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "application page"), "."), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.clientApplicationDetails
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.label
  }, "Client ID:"), /*#__PURE__*/_react.default.createElement(_ClippableText.default, {
    "data-test-id": "success-client-id",
    value: clientId
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.clientApplicationDetails
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.label
  }, "Client Secret:"), /*#__PURE__*/_react.default.createElement(_ClippableText.default, {
    "data-test-id": "success-client-secret",
    value: clientSecret
  })));
};
var ResultModal = function ResultModal(props) {
  var applicationPath = props.applicationPath,
    currentContract = props.currentContract,
    isAPIGroup = props.isAPIGroup;
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var bodyContent = currentContract.status === 'APPROVED' ? /*#__PURE__*/_react.default.createElement(AutoApprovalContent, {
    applicationPath: applicationPath,
    isAPIGroup: isAPIGroup,
    clientId: currentContract.clientId,
    clientSecret: currentContract.clientSecret
  }) : /*#__PURE__*/_react.default.createElement(ManualApprovalContent, null);
  var labelId = 'result-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    onEsc: function onEsc() {
      return closeModal();
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    className: styles.modal,
    testId: "result-modal",
    ariaLabelledBy: labelId
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    onClose: function onClose() {
      return closeModal();
    },
    className: styles.header
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: labelId,
    className: styles.title
  }, "Request ", isAPIGroup ? 'API Group' : 'API', " access")), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    className: styles.body
  }, bodyContent), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    kind: "secondary",
    onClick: function onClick() {
      return closeModal();
    },
    testId: "result-modal-close"
  }, "Close")));
};
ResultModal.defaultProps = {
  isAPIGroup: false
};
var _default = exports.default = ResultModal;
//# sourceMappingURL=ResultModal.js.map